import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import LocationDropdown from "../Component/LocationDropdown";
import { HiMiniMinusSmall, HiMiniPlusSmall } from "react-icons/hi2";
import TimePickerSplit from './TimePickerSplit';
import { useTransferSearch } from "./TransferSearchContext";
import { useNavigate } from "react-router-dom";
const TransfersSearch = ({ resultPage }) => {
  const navigate = useNavigate();

  const { searchData, setSearchData } = useTransferSearch();
  const [isLoading, setIsLoading] = useState(false); // Add this state at the top of your component

  const [passenger, setPassenger] = useState(searchData.passengers || 1);

  const isValidTime = ({ hour, minute } = {}) =>
    hour !== null && Number.isInteger(hour) &&
    minute !== null && Number.isInteger(minute);
  
  const isFormValid = () => {
    //console.log(searchData.time);
    return (
      searchData.from &&
      searchData.to &&
      searchData.date &&
      isValidTime(searchData.time) &&
      passenger > 0
    );
    
  };



  // Sync passenger count to context
  useEffect(() => {
    setSearchData(prev => ({
      ...prev,
      passengers: passenger < 1 ? 1 : passenger,
    }));
  }, [passenger]);

  const getPostcodeFromPlaceId = async (placeId) => {
    const payload = {
      place_id: placeId,
    };
    console.log("placeid:"+placeId);
    try {
      const res = await fetch("https://login.flymiles.com.au/api_sections/transafer/front_end/get_postal_code.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
  
      const result = await res.json();
      console.log(result);
      return result?.postal_code || null;
     
      
    } catch (err) {
      console.error("Search failed", err);
    }

  };
  

  const handleSearch = async () => {
    setIsLoading(true); // Show loader
    let fromAddress = searchData.from?.label || "";
    let toAddress = searchData.to?.label || "";
    let pax = searchData.passengers || "";
    let from_type = "address";
    let to_type = "address";
  
    // Check if source is google-places
    if (searchData.from?.source === "google-places") {
      const postcode = await getPostcodeFromPlaceId(searchData.from.value);
      if (postcode) fromAddress = postcode;
      from_type="postcode";
    }
  
    if (searchData.to?.source === "google-places") {
      const postcode = await getPostcodeFromPlaceId(searchData.to.value);
      if (postcode) toAddress = postcode;
      to_type="postcode";
    }
  
    const payload = {
      from_address: fromAddress,
      from_type: from_type, // optional: set dynamically if you want
      to_address: toAddress,
      to_type: to_type, // optional: set dynamically if you want
      no_of_pax: pax
    };
    //console.log(payload);
    try {
      const res = await fetch("https://login.flymiles.com.au/api_sections/transafer/front_end/search_results.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
  
      const result = await res.json();
      //console.log(result);
      navigate("/transfer-search", { state: { result } });
    } catch (err) {
      console.error("Search failed", err);
    }finally {
      setIsLoading(false); // Hide loader regardless of success or error
    }
  };
  

  const handleFromChange = (value) => {
    setSearchData((prev) => ({ ...prev, from: value }));
  };

  const handleToChange = (value) => {
    setSearchData((prev) => ({ ...prev, to: value }));
  };

  const handleDateChange = (date) => {
    setSearchData((prev) => ({ ...prev, date }));
  };

  const handleTimeChange = (time) => {
    setSearchData((prev) => ({ ...prev, time }));
  };
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  // Dates unavailable for transfers every year, as [month (0-based), day]
  const blockedDates = [
    [0, 1],   // 01 Jan
    [0, 26],  // 26 Jan
    [3, 25],  // 25 Apr
    [11, 24], // 24 Dec
    [11, 25], // 25 Dec
    [11, 26], // 26 Dec
    [11, 31], // 31 Dec
  ];
  const isDateAvailable = (date) =>
    !blockedDates.some(([m, d]) => date.getMonth() === m && date.getDate() === d);

  return (
    <>
    {isLoading && (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        <div className="loader border-t-4 border-white rounded-full w-12 h-12 animate-spin"></div>
      </div>
    )}
    
    <div className={`${resultPage ? "p-3 border rounded-xl" : "w-full"} bg-white`}>
      <div className={`${resultPage ? "lg:flex lg:gap-3" : ""}`}>
        <div className="flex w-full gap-2 pb-2 border-b">
          <img className="h-10 w-10 object-contain" src="/assets/icons/location.png" alt="location" />
          <div className="w-full">
            <label htmlFor="Location" className="flex justify-between text-[#626262] items-center">
              Location (Pick-up from)
            </label>
            <LocationDropdown
              mode="from"
              otherFieldText={searchData.to}
              onChange={handleFromChange}
              value={searchData.from}
            />
          </div>
        </div>

        <div className={`${resultPage ? "mt-4 lg:mt-0" : "mt-4"} flex w-full gap-2 pb-2 border-b`}>
          <img className="h-10 w-10 object-contain" src="/assets/icons/location-2.png" alt="location" />
          <div className="w-full">
            <label htmlFor="Location" className="flex justify-between text-[#626262] items-center">
              Location (Drop-off to)
            </label>
            <LocationDropdown
              mode="to"
              otherFieldText={searchData.from}
              onChange={handleToChange}
              value={searchData.to}
            />
          </div>
        </div>
      </div>

      <div className={`${resultPage ? "lg:flex gap-3" : ""}`}>
        <div className="flex flex-col sm:flex-row items-end gap-4 mt-4">
          <div className="flex gap-2 pb-2 border-b w-full sm:w-1/2">
            <img className="h-10 w-10 object-contain" style={{padding: "2%"}} src="/assets/icons/calendar.png" alt="calendar" />
            <div className="w-full tour-date">
              <label className="text-[#626262] block mb-1">Date</label>
              <DatePicker
                locale="au"
                selected={searchData.date || null} // fallback to tomorrow if not set
                onChange={handleDateChange}
                placeholderText="DD/MM/YYYY"
                dateFormat="dd/MM/yyyy"
                minDate={tomorrow}
                filterDate={isDateAvailable}
              />
            </div>
          </div>
          <div className="flex gap-2 pb-2 border-b w-full sm:w-1/2">
            <img className="h-10 w-10 object-contain" style={{padding: "2%"}} src="/assets/icons/time.png" alt="time" />
            <div className="w-full tour-date">
              <label className="text-[#626262] block mb-1">Arrival or Pickup Time</label>
              <TimePickerSplit selectedTime={searchData.time} onChange={handleTimeChange} />
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-end gap-4 mt-4">
          <div className="flex gap-2 pb-2 border-b w-full sm:w-1/2">
            <img className="h-10 w-10 object-contain" style={{padding: "2%"}} src="/assets/icons/user.png" alt="user" />
            <div className="w-full tour-date">
              <label className="text-[#626262] block mb-1">Passengers</label>
              <div className="flex gap-2 items-center">
                <input
                  className="number-input w-[calc(100%-60px)] placeholder-black text-[18px] border-0 outline-none"
                  type="number"
                  placeholder="0"
                  value={passenger}
                  onChange={(e) => setPassenger(parseInt(e.target.value) || 1)}
                />
                <div className="flex items-center gap-1">
                  <button
                    onClick={() => setPassenger((prev) => (prev > 1 ? prev - 1 : 1))}
                    className="bg-[#FFA100] h-6 w-6 flex items-center justify-center text-white text-2xl"
                  >
                    <HiMiniMinusSmall />
                  </button>
                  <button
                    onClick={() => setPassenger((prev) => prev + 1)}
                    className="bg-[#FFA100] h-6 w-6 flex items-center justify-center text-white text-2xl"
                  >
                    <HiMiniPlusSmall />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button
            disabled={!isFormValid()}
            onClick={handleSearch}
            className={`flex justify-center items-center h-12 text-center rounded-lg w-full sm:w-1/2 ${
              !isFormValid()
                ? 'bg-primary opacity-50 cursor-not-allowed text-white'
                : 'bg-primary text-white'
            }`}
          >
            Search
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default TransfersSearch;
